class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this)); 
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      // console.log(cartLink);
      event.preventDefault();
      this.open(cartLink)
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }


  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {this.classList.add('animate', 'active')});

    this.addEventListener('transitionend', () => {
      const containerToTrapFocusOn = this.classList.contains('is-empty') ? this.querySelector('.drawer__inner-empty') : document.getElementById('CartDrawer');
      const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
      trapFocus(containerToTrapFocusOn, focusElement);
    }, { once: true });

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if(cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    console.log('🛒 [cart-drawer] renderContents called with parsedState:', parsedState);
    this.querySelector('.drawer__inner').classList.contains('is-empty') && this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section => {
      const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
      sectionElement.innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    }));
    
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        console.log('🛒 [cart-drawer] Fetched cart data:', cart);
        console.log('🛒 [cart-drawer] Cart item_count:', cart.item_count);
        this.updateCartBadgeCount(cart.item_count);
      })
      .catch(error => {
        console.error('🛒 [cart-drawer] Error fetching cart:', error);
        const itemCount = parsedState.items?.length || 1;
        this.updateCartBadgeCount(itemCount);
      });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  updateCartBadgeCount(itemCount) {
    console.log('🛒 [cart-drawer] updateCartBadgeCount called with itemCount:', itemCount);
    const cartBadges = document.querySelectorAll('.wbhcartitem');
    console.log('🛒 [cart-drawer] Found badges:', cartBadges.length, cartBadges);
    cartBadges.forEach((badge, index) => {
      console.log(`🛒 [cart-drawer] Badge ${index}:`, badge, 'Current display:', badge.style.display, 'Current text:', badge.textContent);
      if (itemCount > 0) {
        badge.textContent = itemCount;
        if (badge.classList.contains('wbqtyboth')) {
          badge.style.display = 'flex';
          console.log(`🛒 [cart-drawer] Badge ${index} set to flex`);
        } else {
          badge.style.display = 'inline-block';
          console.log(`🛒 [cart-drawer] Badge ${index} set to inline-block`);
        }
      } else {
        badge.style.display = 'none';
        console.log(`🛒 [cart-drawer] Badge ${index} hidden`);
      }
    });
    
    const cartTotals = document.querySelectorAll('.wbcarthtotal');
    console.log('🛒 [cart-drawer] Found cart totals:', cartTotals.length);
    cartTotals.forEach(total => {
      if (itemCount > 0) {
        total.style.display = 'block';
      } else {
        total.style.display = 'none';
      }
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer'
      }
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner'
      }
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
